import { home } from '@/lang/fr/pages/home.ts'
import { pricing } from '@/lang/fr/pages/pricing.ts'
import { avg } from '@/lang/fr/pages/avg.ts'
import { agents } from '@/lang/fr/pages/campaigns/agents.ts'
import { gloriafood } from '@/lang/fr/pages/campaigns/gloriafood.ts'

import { manager } from '@/lang/fr/pages/products/manager.ts'
import { page } from '@/lang/fr/pages/products/page.ts'
import { pos } from '@/lang/fr/pages/products/pos.ts'
import { posdevice } from '@/lang/fr/pages/products/posdevice.ts'
import { qr } from '@/lang/fr/pages/products/qr.ts'
import { webshop } from '@/lang/fr/pages/products/webshop.ts'
import { kiosk } from '@/lang/fr/pages/products/kiosk.ts'

import { lunchroom } from '@/lang/fr/pages/cases/lunchroom.ts'
import { cafetaria } from '@/lang/fr/pages/cases/cafetaria.ts'
import { grillroom } from '@/lang/fr/pages/cases/grillroom.ts'
import { sushi } from '@/lang/fr/pages/cases/sushi.ts'
import { italian } from '@/lang/fr/pages/cases/italian.ts'

import { support } from '@/lang/fr/pages/info/support.ts'
import { faq } from '@/lang/fr/pages/info/faq.ts'
import { downloads } from '@/lang/fr/pages/info/downloads.ts'
import { integrations } from '@/lang/fr/pages/info/integrations.ts'
import { terms } from '@/lang/fr/pages/info/terms.ts'
import { google } from '@/lang/fr/pages/integrations/google.ts'
import { facebook } from '@/lang/fr/pages/integrations/facebook.ts'
import { instagram } from '@/lang/fr/pages/integrations/instagram.ts'
import { mollie } from '@/lang/fr/pages/integrations/mollie.ts'
import { stripe } from '@/lang/fr/pages/integrations/stripe.ts'
import { lightspeed } from '@/lang/fr/pages/integrations/lightspeed.ts'
import { exactonline } from '@/lang/fr/pages/integrations/exactonline.ts'
import { mpluskassa } from '@/lang/fr/pages/integrations/mpluskassa.ts'
import { twilio } from '@/lang/fr/pages/integrations/twilio.ts'
import { winstonpos } from '@/lang/fr/pages/integrations/winstonpos.ts'
import { untill } from '@/lang/fr/pages/integrations/untill.ts'
import { leat } from '@/lang/fr/pages/integrations/leat.ts'
import { slack } from '@/lang/fr/pages/integrations/slack.ts'
import { cashdesk } from '@/lang/fr/pages/integrations/cashdesk.ts'

export const pages = {
  home,
  campaigns: {
    agents,
    gloriafood,
  },
  agents,
  avg,
  products: {
    manager,
    page,
    pos,
    posdevice,
    qr,
    webshop,
    kiosk,
  },
  pricing,
  cases: {
    lunchroom,
    cafetaria,
    grillroom,
    sushi,
    italian,
  },
  info: {
    support,
    faq,
    downloads,
    integrations,
    terms,
    integrations_detail: {
      google,
      facebook,
      instagram,
      mollie,
      stripe,
      lightspeed,
      exactonline,
      mpluskassa,
      twilio,
      winstonpos,
      untill,
      leat,
      slack,
      cashdesk,
    },
  },
}
